import * as React from 'react';
import styled from 'styled-components';

const colors = {
  old: {
    defaultBackgroundColor: '#38C5F3',
    defaultBorderColor: '#38C5F3',
    doneBackgroundColor: '#FFC708',
  },
  new: {
    defaultBackgroundColor: '#E7E9EE',
    defaultBorderColor: '#E7E9EE',
    doneBackgroundColor: '#002169',
    doneBorderColor: '#002169',
  },
};

export const SHorizontalStepper = styled.div<{}>(({ theme }) => {
  return `
    margin: 20px auto 0 auto;
    display:flex;
    justify-content: space-around;
    align-items: center;
    padding: 0px 50px;
    width: 400px;
    @media only screen and ${theme.device.max.laptopS} {
      width: 90vw;
      margin-top: 10px;
      box-sizing: border-box;
    }
  `;
});

export const SStep = styled.div<{}>(({}) => {
  return `
    display: flex;
    flex-direction: column;
    align-items: center;
  	padding: 10px 0;
  `;
});

export const SCircle = styled.div<{ newFlow: boolean }>(({ theme, newFlow }) => {
  return `
    width: 20px;
    height: 20px;
    margin:0 auto;
    background-color: ${newFlow ? colors.new.defaultBackgroundColor : colors.old.defaultBackgroundColor};
    border: 2px solid ${newFlow ? colors.new.defaultBorderColor : colors.old.defaultBorderColor};
    border-radius: 50%;
    text-align: center;
    line-height: 30px;
    font-size: 16px;
    font-weight: 600;
    box-sizing: border-box;

    z-index: 2;
    &.checked {
      background-color: ${newFlow ? colors.new.doneBackgroundColor : colors.old.doneBackgroundColor};
      border: 2px solid ${newFlow ? colors.new.doneBackgroundColor : colors.old.defaultBorderColor};
    }
    &.done{
      width: 20px;
      background-color: ${newFlow ? theme.colors.primaryBright : colors.old.defaultBackgroundColor};
      border: 2px solid ${newFlow ? theme.colors.primaryBright : colors.old.defaultBorderColor};

    }
    &::before {
      content: attr(data-textbefore);
      display: block;
      margin-top: -6px;
      color: ${theme.colors.mediumGray};
      font-size: 10px;
    }
    &.checked&::before {
      content: "";
      display: block;
      transform: rotate(45deg);
      height: 8px;
      width: 3px;
      margin-left: 6px;
      margin-top: 2px;
      border-bottom: 1px solid white;
      border-right: 1px solid white;
    }
    &.done&::before {
      color: ${theme.colors.white};
    }

  `;
});

export const STitle = styled.div<{ newFlow: boolean }>(({ newFlow, theme }) => {
  return `
    margin-top: 10px;
    font-size: 10px;
    text-align: center;
    font-weight: ${theme.font.weight.boldest};
    color: ${newFlow ? 'transparent' : colors.old.defaultBorderColor};
    &.done {
      color: ${newFlow ? theme.colors.primaryBright : colors.old.defaultBorderColor};
      font-weight: ${theme.font.weight.bold};
    }
    &.incomplete {
      color: ${newFlow ? colors.new.defaultBorderColor : colors.old.defaultBorderColor};
      font-weight: ${theme.font.weight.bold};
    }
  `;
});

export const SBar = styled.div<{ newFlow: boolean }>(({ newFlow }) => {
  return `
    height: 0;
    margin-bottom: 25px;
    border-top: 1px solid ${newFlow ? colors.new.defaultBackgroundColor : colors.old.defaultBorderColor};
    width: 100%;
    margin-left: -15px;
    margin-right: -15px;
    &.done {
      border-color: ${newFlow ? colors.new.doneBorderColor : colors.old.defaultBorderColor};
    }
`;
});

export interface IProgress {
  step: number;
  titles: string[];
  newFlow?: boolean;
  showAllTitles?: boolean;
}

// tslint:disable-next-line:variable-name
const ProgressBW: React.FC<IProgress> = (props) => {
  const getTitleClassName = (index: number) => {
    if (props.showAllTitles) {
      if (props.step === index || props.step > index) {
        return 'done';
      }
      return 'incomplete';
    }

    return props.step === index ? 'done' : '';
  };
  return (
    <SHorizontalStepper>
      {props.titles &&
        props.titles.map((title, index) => {
          return (
            <React.Fragment key={`steper_${index}`}>
              <SStep>
                <SCircle
                  newFlow={props.newFlow}
                  data-textbefore={(index + 1).toString()}
                  className={props.step > index ? 'checked' : props.step == index ? 'done' : ''}
                />
                <STitle newFlow={props.newFlow} className={getTitleClassName(index)}>
                  {title}
                </STitle>
              </SStep>
              {props.titles.length - 1 > index && (
                <SBar newFlow={props.newFlow} className={props.step > index ? 'done' : ''}></SBar>
              )}
            </React.Fragment>
          );
        })}
    </SHorizontalStepper>
  );
};

export default ProgressBW;
